module.exports = __webpack_public_path__ + "static/media/69 - Lucio Battisti - Ancora tu.39f91abf.mp3";